export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
  setNewPayment(state, { payload }) {
    state.payments = [...state.payments, ...[payload]];
  },
  delProperty(state, { property }) {
    state.payments = state.payments.filter(el => el.id !== property);
  },
};
